import { memo } from "react";
import { formattedDate, formattedDateTimeWithoutSec } from "../../../lib/functions";

interface AccompanyingPersonnelDetailsProps {
    permitPersonnel: {
        s_PersonnelName: string;
        nationality_En: string;
        s_Iqama: string;
        dt_IqamaIssue: any;
        s_IssuingAuthority: string;
        haveIqamaUpload: boolean;
    }[]
}

const AccompanyingPersonnelDetails = ({ permitPersonnel }: AccompanyingPersonnelDetailsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-t border-black py-0.5">
                <span className="text-[10px] text-white font-bold">
                    Section 3: Accompanying Personnel Details
                </span>
            </div>

            <table className="w-full text-xs">
                <thead>
                    <tr className="bg-gray-300">
                        <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
                            Name
                        </th>
                        <th className="border-y-[0.2px] border-l-[0.2px] border-black p-1 text-[10px] h-4">
                            Nationality
                        </th>
                        <th className="border-[0.2px] border-black p-1 text-[10px] h-4">
                            Residence Permit No.
                        </th>
                        <th className="border-y-[0.2px] border-l-[0.2px] border-r-[0.2px] border-black p-1 text-[10px] h-4">
                            Issuing Authority
                        </th>
                        <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
                            Issue Date
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {permitPersonnel?.map((row, idx) => (
                        <tr key={idx}>
                            <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {row.s_PersonnelName}
                            </td>
                            <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {row.nationality_En}
                            </td>
                            <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {row.s_Iqama}
                            </td>
                            <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {row.s_IssuingAuthority}
                            </td>
                            <td className="border-b-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {formattedDate(new Date(row.dt_IqamaIssue))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default memo(AccompanyingPersonnelDetails);
